export const FirmwareStatuses: string[]  = [
    'Non Published',
    'Internally Released',
    'Published'
];


// WEBPACK FOOTER //
// ./src/app/dicts/firmware-statuses.ts